exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.titleComponent {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 18px;\n  color: #1B1918;\n}\n.styleSubTitle {\n  color: #2E4057;\n  font-weight: 400;\n  line-height: 18px;\n  font-size: 12px;\n}\n.styleStatus {\n  font-size: 11px;\n  line-height: 13px;\n  color: #1B1918;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c2250fc","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/LMSGiframe/components/DocumentTypeHeader.vue
// module id = 1556
// module chunks = 2